import React from 'react';
import './Section.css';
import './About.css';

export default function About() {
  return (
    <section id="about" className="section">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-num">01.</span>
          <h2 className="section-title">about me</h2>
          <div className="section-line" />
        </div>

        <div className="about-grid">
          <div className="about-text">
            <p>
              I'm a <span className="hl">Third-year BE student</span> at Thapar Institute of Engineering and Technology,
              Patiala, with a deep obsession for building things that matter. My work lives at the intersection of
              <span className="hl"> machine learning, NLP, and full-stack engineering</span>.
            </p>
            <p>
              I've worked as a Research Fellow for <span className="hl">MoSPI, Government of India</span>, building
              ensemble ML pipelines to inform national economic policy. Simultaneously, I'm a Software Engineer Intern
              at <span className="hl">TOSS</span>, where I architect NLP-driven voicebots for major clients like ICICI Bank.
            </p>
            <p>
              In 2024, I co-founded <span className="hl">EvexFitness AI LLP</span> — leading a 20-member team to ship
              a real-time AI posture correction platform powered by Computer Vision. I've competed in hackathons at
              IIT Gandhinagar, won international prizes, and kept building.
            </p>
            <p>
              When I'm not coding, I'm probably reading research papers, contributing to OCR for low-resource languages,
              or mentoring other developers.
            </p>
          </div>

          <div className="about-edu">
            <h3 className="edu-title">// education</h3>
            <div className="edu-items">
              <div className="edu-item">
                <div className="edu-dot" />
                <div>
                  <div className="edu-school">Thapar Institute of Engineering & Technology</div>
                  <div className="edu-degree">B.E. — Aug 2023 – July 2027</div>
                  <div className="edu-loc">Patiala, India</div>
                </div>
              </div>
              <div className="edu-item">
                <div className="edu-dot" />
                <div>
                  <div className="edu-school">Modern School, Faridabad</div>
                  <div className="edu-degree">PCM, CBSE XII — 80.8% · 2023</div>
                </div>
              </div>
              <div className="edu-item">
                <div className="edu-dot edu-dot-last" />
                <div>
                  <div className="edu-school">Modern School, Faridabad</div>
                  <div className="edu-degree">CBSE X — 88.6% · 2021</div>
                </div>
              </div>
            </div>

            <div className="about-contact-row">
              <a href="mailto:krishkumar18022005@gmail.com" className="contact-chip">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                krishkumar18022005@gmail.com
              </a>
              <a href="https://linkedin.com/in/krish-kumar-2951101b5/" target="_blank" rel="noreferrer" className="contact-chip">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
                LinkedIn
              </a>
              <span className="contact-chip phone">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.1a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                +91 8448125163
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
